module.exports = __webpack_public_path__ + "static/img/img-logo-hik-insan-cita.87d17fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-hik-insan-cita.png
// module id = F96N
// module chunks = 36